module.exports = __webpack_public_path__ + "static/img/jszc_qr.de4b52c0.png";